<template>
<div class="container">
    <Breadcrumbs :here="'請求承認受付設定'"
                 :ancestries="ancestries"/>
    <div class="row">
        <div class="col h2"
             :style="{ fontSize: FontSizes.large2}">請求承認受付設定</div>
    </div>

    <div class="row justify-content-start mb-2">
        <div class="col-md-4 col-sm">

        </div>
    </div>

</div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import {backendApi} from "@/utils/backend-api";
import {Staff} from "@/data-models/staff";
import {logoutMessages, subPaths} from "@/utils/consts";
import {loadingOverlayStateStore} from "@/stores/loading-overlay-state-store";
import ClearableInput from "@/components/ClearableInput.vue";
import {FontSizes} from "@/utils/font-sizes";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import {downloadZIPFile} from "@/utils/file-utils";
import PopupMenu, {popupMenuItemType, popupPositionType} from "@/components/PopupMenu.vue";
import MenuButton from "@/components/MenuButton.vue";
import {confirmDialogStateStore} from "@/stores/confirm-dialog-state-store";
import {toastStore} from "@/stores/toast-store";

export default defineComponent({
    name: "Branch",
    components: { Breadcrumbs },
    setup() {

        const route = useRoute(),
            router = useRouter()


        onMounted(async () => {
            loadingOverlayStateStore.commit("fadeout")
        })


        return {
            FontSizes,
            ancestries: [
                {
                    name: "ホーム",
                    pathObj: subPaths.HOME
                }
            ],
        }
    }
})
</script>

<style scoped lang="scss">
.staff-table-wrap {

    //height: calc(100vh - 150px);
    overflow-y: auto;
    //background-color: red;

    .table {

        thead th {
            position: sticky;
            top: 0;
            z-index: 1;
            background-color: whitesmoke;
            box-shadow: 1px 1px 3px #AAA;
        }

        button {
            //font-size: 1.5vw;
        }


    }
}


</style>